import React, { useState } from 'react';

import Episode from '../episode/Episode';
import LoadMore from '../load-more/LoadMore';

import { EpisodesContainer } from './Episodes.styles';

const Episodes = ({ podcastData }) => {
  const [loadedEpisodes, setLoadedEpisodes] = useState(podcastData.episodes);
  const [nextPage, setNextPage] = useState(podcastData.next_episode_pub_date);

  // Check if all episodes are loaded
  const isShowingAll =
    loadedEpisodes.length < podcastData.total_episodes ? false : true;

  return (
    <EpisodesContainer>
      {loadedEpisodes.map(episode => (
        <Episode
          key={episode.id}
          episode={episode}
          author={podcastData.title}
          authorId={podcastData.id}
        />
      ))}
      {!isShowingAll && (
        <LoadMore
          nextPage={nextPage}
          id={podcastData.id}
          setLoadedEpisodes={setLoadedEpisodes}
          setNextPage={setNextPage}
          episodes={loadedEpisodes}
        />
      )}
    </EpisodesContainer>
  );
};

export default Episodes;
